<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="handleBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>{{ $route.query.name }}推广名单数</p>
      </div>
    </div>

    <div class="promotion-list">
      <el-form class="mwow-wrap form" size="mini">
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员:" prop="keyword">
              <el-input
                v-model="searchInfo.keyword"
                placeholder="请输入学员姓名或手机号"
                clearable
                @change="handleSearch"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="市场顾问:" prop="title">
              <el-select
                v-model="searchInfo.staff_id"
                placeholder="请输入市场顾问姓名或手机号"
                clearable
                filterable
                :filter-method="handleSearchMarketStaff"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in market_staff_list"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="item.staff_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="创建时间:" prop="create_time">
              <common-date-range-selector
                v-model="searchInfo.create_time"
                start-placeholder="开始时间"
                range-separator="至"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch()"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="活动类型:" prop="type_id">
              <el-select
                v-model="searchInfo.type_id"
                placeholder="请输入活动类型"
                clearable
                @clear="handleSearchType('')"
                filterable
                :filter-method="handleSearchType"
                @change="handleSearch"
                @visible-change="handleVisible"
              >
                <el-option
                  v-for="item in activityTypeList"
                  :key="item.type_id"
                  :label="item.title"
                  :value="item.type_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="活动名称:" prop="activity_id">
              <el-select
                v-model="searchInfo.activity_id"
                placeholder="请输入活动名称"
                clearable
                @clear="handleSearchTitle('')"
                filterable
                :filter-method="handleSearchTitle"
                @change="handleSearch"
                @visible-change="handleVisible"
              >
                <el-option
                  v-for="item in activityTitleList"
                  :key="item.activity_id"
                  :label="item.title"
                  :value="item.activity_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <br />
      <el-table
        size="mini"
        :data="tableData"
        stripe
        ref="tableRef"
        style="width: 100%"
        tooltip-effect="dark"
        class="table"
      >
        <el-table-column label="序号" type="index" width="70">
        </el-table-column>
        <el-table-column label="学员姓名" prop="name">
          <template slot-scope="scope">
            {{ scope.row.name ? scope.row.name : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="mobile"> </el-table-column>
        <el-table-column label="定位地址" prop="location_address">
          <template slot-scope="scope">
            {{ scope.row.location_address ? scope.row.location_address : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="出现方式" prop="appear_name"> </el-table-column>
        <el-table-column
          label="来源渠道"
          prop="student_source.name"
        ></el-table-column>
        <el-table-column
          label="活动名称"
          prop="activity.title"
        ></el-table-column>
        <el-table-column label="活动类型" prop="type.title"></el-table-column>
        <el-table-column
          label="创建时间"
          prop="create_time"
          width="200"
        ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="pageSizeArray"
        :style="{ float: 'right', padding: '20px' }"
        :total="total"
        @current-change="handlePagerChange"
        @size-change="handlePagerSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getActivityRosterListApi,
  getActivitySelectTypeListApi,
  getActivitySelectListApi,
  getMarketStaffListApi,
} from "@/api/marketActivity";
import { dateFormat } from "@/utils/timeFormat";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  name: "promotionList",
  components: {
    commonDateRangeSelector,
  },
  data() {
    return {
      searchInfo: {},
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      tableData: [],
      activityTypeList: [],
      activityTitleList: [],
      market_staff_list: [],
      timer: "",
      effectiveDate: {
        disabledDate(date) {
          return date > Date.now();
        },
      },
    };
  },

  created() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
    this.getActivietySelectTypeList();
    this.getActivitySelectList();
    this.getMarketStaffListApiFn();
  },
  methods: {
    solveSearchInfo(option) {
      let params = { ...option };
      if (this.searchInfo.keyword) {
        params.keyword = this.searchInfo.keyword;
      }
      if (this.searchInfo.type_id) {
        params.type_id = this.searchInfo.type_id;
      }
      if (this.searchInfo.activity_id) {
        params.activity_id = this.searchInfo.activity_id;
      }
      if (this.$route.query.market_staff_id !== "") {
        params.market_staff_id = this.$route.query.market_staff_id;
      }
      if (this.searchInfo.staff_id) {
        params.market_staff_id = this.searchInfo.staff_id;
      }
      if (this.searchInfo.create_time) {
        params.create_start_time =
          new Date(this.searchInfo.create_time[0] + " 00:00:01").getTime() /
          1000;
        params.create_end_time =
          new Date(this.searchInfo.create_time[1] + " 23:59:59").getTime() /
          1000;
      }
      return params;
    },
    getList(params) {
      let option = this.solveSearchInfo(params);
      if (Number(this.$route.query.market_staff_id) === 0) {
        option.is_official = 1;
      }
      getActivityRosterListApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            item.create_time = item.create_time
              ? dateFormat("YYYY-mm-dd HH:MM", item.create_time * 1000)
              : "-";
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    // 获取市场顾问列表
    getMarketStaffListApiFn(v) {
      getMarketStaffListApi({
        page: 1,
        page_size: 100,
        keyword: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.market_staff_list = res.data.list;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    // 模糊搜索 - 市场顾问
    handleSearchMarketStaff(v) {
      this.debounce(this.getMarketStaffListApiFn, v, 500);
    },
    debounce(fn, data, delay) {
      // 设置一个触发开关
      let _t = this;
      clearTimeout(_t.timer);
      _t.timer = setTimeout(() => {
        fn(data);
      }, delay);
    },
    // 活动名称列表
    getActivitySelectList(v) {
      getActivitySelectListApi({
        page: 1,
        page_size: 100,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.activityTitleList = res.data.list;
        }
      });
    },
    // 活动类型列表
    getActivietySelectTypeList(v) {
      getActivitySelectTypeListApi({
        page: 1,
        page_size: 100,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.activityTypeList = res.data.list;
        }
      });
    },
    // 模糊搜索 - 活动名称
    handleSearchTitle(v) {
      this.getActivitySelectList(v);
    },
    // 模糊搜索 - 活动类型
    handleSearchType(v) {
      this.getActivietySelectTypeList(v);
    },
    // 列表下拉
    handleVisible(v) {
      if (v) {
        this.getActivietySelectTypeList();
        this.getActivitySelectList();
      }
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleBack() {
      this.$router.push({
        name: "marketingPromotion",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 70px 12px;
  border-radius: 4px;
}
.promotion-list {
  padding: 20px 0;
}
/deep/.form {
  .el-form-item {
    display: flex;
    .el-form-item__label {
      min-width: 100px !important;
    }
    .el-form-item__content {
      width: 74%;
      div:nth-child(1) {
        width: 100%;
      }
    }
    .el-select {
      width: 100% !important;
    }
  }
}

.table {
  .btns {
    display: flex;
  }
}
</style>
